import delivery from './delivery.js'
import websocket from '../websocket'
import privacy from '@pt/store/privacy'
import loginToSs from '@pt/store/user/login-ss'
import download from '@pt/store/pt/download'
import trial from '@pt/store/pt/trial'
import feedback from '@pt/store/pt/feedback.js'

const creative = {
  namespaced: true,
  state: {
    module: '', // dmaker、gmaker
    isDMaker: false,
    isGMaker: false,
    jobUpdated: false,
  },
  mutations: {
    updateModule(state, value) {
      const utils = {
        dmaker: () => {
          state.isDMaker = true
          state.isGMaker = false
        },
        gmaker: () => {
          state.isDMaker = false
          state.isGMaker = true
        },
        common: () => {
          state.isDMaker = false
          state.isGMaker = false
        },
      }
      state.module = value
      utils[value] && utils[value]()
    },
    updateJobUpdated(state, value) {
      state.jobUpdated = value
    },
  },
  actions: {
    loginToSs({ state }, params) {
      return loginToSs(params)
    },
  },
  modules: {
    delivery,
    websocket,
    privacy,
    download,
    trial,
    feedback,
  },
}

export default creative
